import Model  from '@/utils/models';

export default class Product extends Model { 
    backend = '/survey/partai/';           

    uploadImage(formdata, params={}){
        return this.api.post(this.backend + 'upload-image', formdata, params, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    }
}

